import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container'
import Image from 'react-bootstrap/Image'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import { hot } from 'react-hot-loader';
import { FaUser } from 'react-icons/fa'
import { HiArrowRight } from 'react-icons/hi';
import { useDispatch } from 'react-redux';

import { isForbidden } from '../../lib/ForbiddenException';
import { aboutUrl } from '../../modules/About/urls';
import { changePasswordUrl } from '../../modules/ChangePassword/urls';
import { homeUrl } from '../../modules/Home/urls';
import { consentUrl, inquiryUrl } from '../../modules/Inquiry/urls';
import { logout } from '../../modules/Login/slice';
import { loginUrl } from '../../modules/Login/urls';
import viewerUrl from '../../modules/Viewer/urls';
import { retrieveMe } from '../../sdk/apis';
import BaseButton from '../BaseButton';
// import Logo from '../../../../../static/media/logo.png'
// ↑なぜかダメ
import ASEBI from './ASEBI.png';
import NIED from './NIED.png';

const TitleBar = () => {
  const [adminSiteLink, setAdminSiteLink] = useState();
  const [letter, setLetter] = useState('ログイン');
  const [letterEn, setLetterEn] = useState('Log in');
  const [viewerLink, setViewerLink] = useState();
  const [changePasswordLink, setChangePasswordLink] = useState();
  const [createAccountLink, setCreateAccountLink] = useState(<Nav.Link href={consentUrl('account')}><small>新規アカウント申請<br />Application for a New Account</small></Nav.Link>);
  const [loginInfo, setLoginInfo] = useState();
  const [inquiryLink, setInquiryLink] = useState(<Nav.Link href={consentUrl()}><small>お問い合わせ<br />Inquiry</small></Nav.Link>)
  const adminUrl = '/admin/';
  const dispatch = useDispatch();


  useEffect(async () => {
    let isActive = false;
    let accountId = "";
    let expiration_date = "";
    const result = await dispatch(retrieveMe);

    accountId = result.account_id;
    expiration_date = result.expiration_date.split('T')[0].replaceAll('-', '/');
    // }).catch((error) => {
    //   isStaff = false;
    //   isActive = false;
    //   accountId = "";
    //   expiration_date = "";
    // })
    if (result === undefined) {
      //   setLetter('ログイン')
      // letter = 'ログイン';
      // viewerLink = null;
      // changePasswordLink = null;
      // loginInfo = null;
      // adminSiteLink = null;
    } else {
      setLetter('ログアウト');
      setLetterEn('Log out');
      setInquiryLink(<Nav.Link href={inquiryUrl()}><small>お問い合わせ<br />Inquiry</small></Nav.Link>)
      setCreateAccountLink(<></>);
      setViewerLink(<Nav.Link href={viewerUrl.base}><small>実験一覧<br />List of Experiments</small></Nav.Link>);
      setChangePasswordLink(<Nav.Link href={changePasswordUrl()}><small>パスワード変更<br />Change Password</small></Nav.Link>);
      if (result.category === 'manager') {
        setAdminSiteLink(<Nav.Link href={adminUrl}><small>管理者用サイト<br />Admin Site</small></Nav.Link>)
        setLoginInfo(<><FaUser /><small>{accountId}(管理者)</small></>);
      } else {
        setLoginInfo(<><FaUser /><small>{accountId}  &nbsp;有効期限：{expiration_date}</small></>);
      }
    }
  }, []);

  return (
    <>
      <Nav bg="light bg-opacity-25" variant="light">
        <Container>
          <small><a href={"https://www.bosai.go.jp/"}><img src={NIED} style={{ width: '150px', padding: '0.6em', float: 'right' }} /></a></small>
        </Container>
      </Nav>
      <Navbar collapseOnSelect expand="lg" bg="success bg-opacity-25" variant="light">
        <Container>
          <Navbar.Brand className="my-2 my-lg-0" width="60">
            <Image src={ASEBI} className="d-inline-block align-top img-fluid" style={{width: '175px', marginRight: '1rem'}} alt="ASEBI" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto">
              <Nav.Link href={homeUrl()}><small>トップ<br />Top</small></Nav.Link>
              <Nav.Link href={aboutUrl()}><small>ASEBIについて<br />About ASEBI</small></Nav.Link>
              {inquiryLink}
              {createAccountLink}
              {viewerLink}
              {changePasswordLink}
              {adminSiteLink}
            </Nav>
          </Navbar.Collapse>
          <Nav>
            {loginInfo}
          </Nav>
          <BaseButton className="form-inline my-2 my-lg-0" variant="outline-secondary" onClick={() => {
            dispatch(logout());
          }}>
            <HiArrowRight />&nbsp;
            {letter}
            <br />
            {letterEn}
          </BaseButton>
        </Container>
      </Navbar >
    </>
  );
};

export default hot(module)(TitleBar);
